import * as React from 'react';
import { captureErrorSentry } from '../utils';

type AggregatedErrorType = Error;

interface Props {
	renderFallback: (error: AggregatedErrorType) => React.ReactElement;
}

interface State {
	error: AggregatedErrorType;
}

export default class ErrorBoundary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			error: null
		};
	}

	public static getDerivedStateFromError(error: AggregatedErrorType) {
		return {
			error: error
		};
	}

	public componentDidCatch(error: AggregatedErrorType, errorInfo: React.ErrorInfo): void {
		captureErrorSentry(`${error?.name}: ${error?.message}`);
	}

	public render() {
		const { children, renderFallback } = this.props;
		const { error } = this.state;

		if (error) {
			return renderFallback(error);
		}

		return children;
	}
}
